import React, { useEffect } from 'react';

// This component dynamically injects the Google Analytics script into the page.
const GoogleAnalyticsScript = ({ measurementId }) => {
  useEffect(() => {
    // If no measurementId is provided, do nothing.
    if (!measurementId) return;

    // Create the script element for gtag.js
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;

    // Append the script to the head of the document
    document.head.appendChild(script);

    // Initialize the dataLayer and gtag function
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    // Set the initial date and configuration
    gtag('js', new Date());
    gtag('config', measurementId);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, [measurementId]); // Re-run the effect if the measurementId changes

  return null; // This component doesn't render any visible elements
};

export default GoogleAnalyticsScript;
